module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "check-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm.i18n.screenResolution))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.result.text))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('checker-status', {
    attrs: {
      "result": _vm.result.value
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.result.value === 'failed'),
      expression: "result.value === 'failed'"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.i18n.results.screenResolution))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56389caf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScreenResolution.vue
// module id = 288
// module chunks = 2